import { toWSMoneyString } from "@wingspanhq/fe-component-library";

export const formatReportMoney = (value?: number) => {
  return typeof value === "number" ? toWSMoneyString(value) : undefined;
};
